// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Person extends TrackingModel {
	public PersonId: number = 0;
	public UserUID?: string;
	public FirstName: string = "";
	public MiddleNames?: string;
	public LastName: string = "";
	public Suffix?: string;
	public DOB?: Date;
	public AvatarBlobPath?: string;
}